import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Contact from "@/pages/Contact";
import Photos from "@/pages/Photos";
import Remerciement from "@/pages/Remerciement";
import SplashScreen from "@/components/SplashScreen";
import { Toaster } from "@/components/ui/sonner";
import { EventDialogProvider } from "@/context/EventDialogContext";

function App() {
  const [splashDone, setSplashDone] = useState(false);

  return (
    <div className="App">
      {!splashDone && <SplashScreen onComplete={() => setSplashDone(true)} />}
      <BrowserRouter>
        <EventDialogProvider>
          <Header />
          <main className="pt-20">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/photos" element={<Photos />} />
              <Route path="/remerciement" element={<Remerciement />} />
            </Routes>
          </main>
          <Footer />
          <Toaster />
        </EventDialogProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
